import { render, staticRenderFns } from "./SmsActivateNumber.vue?vue&type=template&id=6157465c&"
import script from "./SmsActivateNumber.vue?vue&type=script&lang=js&"
export * from "./SmsActivateNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports